import { GET_AUDIT_SECURITY_ALL } from "../types";

const initialState = {
  auditSecurityAll: [],
};

export const auditSecurityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUDIT_SECURITY_ALL:
      return (() => ({
        ...state,
        auditSecurityAll: action.data,
      }))();
    default:
      return state;
  }
};
